// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const File: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M8.5 17.5h7v-1h-7v1Zm0-4h7v-1h-7v1ZM5 21V3h9.5L19 7.5V21H5Zm9-13V4H6v16h12V8h-4Z"
            />
        </svg>
    );
};

export const FileOffset: IconOffset = {
    vertical: 12,
    horizontal: 20,
};

export default React.memo(File);
